
riot.tag2('images-gallery-modal', '  <bs-modal name="modal">\n    <yield to="title">\n      <div class="h4 modal-title">Библиотека изображений</div>\n    </yield>\n    <yield to="body">\n      <image-gallery name="gallery" hide-unised="true" dblclick="{parent.opts.submit.bind(this)}"></image-gallery>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    self.tags.modal.tags.gallery.update({ params: { section: opts.section, limit: 10, offset: 0 } });
    self.tags.modal.tags.gallery.reload();
});
});


// WEBPACK FOOTER //
// ./pages/images/images-gallery-modal.tag